// UploadTab Constants
export const TABLE_COLUMNS = {
  NAME: 'Name',
  SIZE: 'Size',
  VALIDATION_STATUS: 'Validation Status',
  STATUS: 'Status',
  ACTIONS: 'Actions',
  ICONS: 'Icons'
};

export const VALIDATION_STATUSES = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

export const FILE_STATUSES = {
  UPLOADED: 'UPLOADED',
  PROCESSING: 'PROCESSING',
  SAVED: 'SAVED'
};

export const BUTTON_SIZES = {
  ACTION_BUTTON: {
    minWidth: '100px',
    height: '32px'
  },
  ICON_BUTTON: {
    size: 'small'
  }
};

export const TABLE_STYLES = {
  ROW: {
    minHeight: '80px',
    hoverBg: 'rgba(0, 0, 0, 0.04)',
    cellPadding: 'py: 2'
  },
  ACTIONS_CELL: {
    minHeight: '80px',
    padding: 'py: 2'
  }
};

export const REFRESH_INTERVAL = 10000;
